// src/pages/doctors/DoctorProfile.jsx - COMPLETE FIXED VERSION
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import doctorService from '../../../services/doctorService';
import '../../../styles/components/doctor/DoctorProfile.css';

import EyeOpen from '../../../assets/icons/indicators/eye_open_icon.svg';
import EyeClosed from '../../../assets/icons/indicators/eye_closed_icon.svg';
import uploadIcon from '../../../assets/icons/indicators/upload_image_icon.svg';



import neurolexLogo from '../../../assets/images/Neurolex_Logo_New.png';

// Import icons
import editIcon from '../../../assets/icons/profile_icon.svg';
import settingsIcon from '../../../assets/icons/pub_profile.svg';
import profileIcon from '../../../assets/icons/doctor_application_icon.svg';
import keyIcon from '../../../assets/icons/change_icon.svg';
import helpIcon from '../../../assets/icons/help_icon.svg';
import logoutIcon from '../../../assets/icons/logout_icon.svg';

const safeRender = (value, fallback = 'Not provided') => {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }
  
  if (typeof value === 'object') {
    if (Array.isArray(value)) {
      return value.length > 0 ? value.join(', ') : fallback;
    }
    return JSON.stringify(value);
  }
  
  return String(value);
};

 // View Modal Component
const ViewPublicProfileModal = ({ 
  showViewModal, 
  setShowViewModal, 
  setShowEditModal, 
  doctorProfile,
  safeRender 
}) => {
  if (!showViewModal) return null;
  
  return (
    <div className="modal-overlay" onClick={() => setShowViewModal(false)}>
      <div className="modal-content large-modal" onClick={(e) => e.stopPropagation()}>
        <div className="doc-profile-modal-header">
          <button className="doc-profile-modal-close" onClick={() => setShowViewModal(false)}>×</button>
        </div>
        
       <div className="doctor-profile-modal-body">
  <div className="public-profile-preview">
    {/* Doctor Header - Name and Title Only */}
 <div className="doctor-header-section">
  <div className="doc-profile-doctor-photo">
    {doctorProfile.profilePicture ? (
      <img src={doctorProfile.profilePicture} alt="Doctor" className="doctor-photo-img" />
    ) : (
      <div className="doctor-photo-placeholder">
        {safeRender(doctorProfile.firstName?.charAt(0), '')}{safeRender(doctorProfile.lastName?.charAt(0), '')}
      </div>
    )}
  </div>
  
  <div className="doc-profile-doctor-info">
    <h3 className="doctor-name">
      {doctorProfile.title ? `${doctorProfile.title} ` : ''}
      {safeRender(doctorProfile.firstName)} {safeRender(doctorProfile.lastName)}
    </h3>
    <p className="doctor-specialty">
      {safeRender(doctorProfile.specialty || doctorProfile.specialization, 'General Practitioner')}
    </p>
  </div>

  {/* Bio section - Outside doctor-info div, but still inside header-section */}
  {(doctorProfile.professionalBio || doctorProfile.bio) && (
    <div className="doctor-bio-section">
      <p className="bio-text">{safeRender(doctorProfile.professionalBio || doctorProfile.bio)}</p>
    </div>
  )}
</div>


            <div className="profile-section personal-info-section">
              <h4>Personal Information</h4>
              <div className="info-grid">
                <div className="info-item">
                  <label>First Name:</label>
                  <span>{safeRender(doctorProfile.firstName)}</span>
                </div>
                <div className="info-item">
                  <label>Last Name:</label>
                  <span>{safeRender(doctorProfile.lastName)}</span>
                </div>
                <div className="info-item">
                  <label>Email Address:</label>
                  <span>{safeRender(doctorProfile.email)}</span>
                </div>
                <div className="info-item">
                  <label>Personal Contact Number:</label>
                  <span>{safeRender(doctorProfile.personalContactNumber || doctorProfile.phoneNumber)}</span>
                </div>
                <div className="info-item">
                  <label>Clinic Location:</label>
                  <span>{safeRender(doctorProfile.clinicAddress || doctorProfile.clinicLocation)}</span>
                </div>
                <div className="info-item">
                  <label>Clinic Contact Number:</label>
                  <span>{safeRender(doctorProfile.clinicContactNumber)}</span>
                </div>
              </div>
            </div>

           {/* Services Offered */}
  <div className="profile-section sidebar-section">
  <div className="services-list">
    {(doctorProfile.inPerson || doctorProfile.appointmentTypes?.inPerson) && (
      <span className="service-item available">
        <span className="service-icon"></span>
        <span>In-Person Consultations</span>
      </span>
    )}
    
    {(doctorProfile.telehealth || doctorProfile.appointmentTypes?.telehealth) && (
      <span className="service-item available">
        <span className="service-icon"></span>
        <span>Telehealth Services</span>
      </span>
    )}
    
    {doctorProfile.emergencyAware && (
      <span className="service-item available">
        <span className="service-icon">✅</span>
        <span>Emergency Consultations</span>
      </span>
    )}
  </div>
</div>

{/* Availability Section - FILTERED VERSION */}
{(() => {
  // Filter to show only days that are available
  const availableDays = doctorProfile.availability ? 
    Object.entries(doctorProfile.availability).filter(([day, schedule]) => schedule?.available) : 
    [];
  
  if (availableDays.length === 0) {
    return null; // Don't show section at all if no available days
  }
  
  return (
    <div className="profile-section sidebar-section">
      <div className="availability-grid">
        {availableDays.map(([day, schedule]) => (
          <div key={day} className="availability-day">
            <div className="doc-profile-day-name">
              {day.charAt(0).toUpperCase() + day.slice(1)}
            </div>
            {schedule.slots && schedule.slots.length > 0 && (
              <div className="time-slots">
                {schedule.slots.map((slot, index) => (
                  <span key={index} className="time-slot">
                    {slot.startTime} - {slot.endTime}
                  </span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
})()}


            {/* Education Section (if available) */}
            {doctorProfile.education && doctorProfile.education.length > 0 && (
              <div className="profile-section">
                <h4>Education</h4>
                <div className="credentials-list">
                  {doctorProfile.education.map((edu, index) => (
                    <div key={index} className="credential-item">
                      <div className="credential-main">
                        <strong>{safeRender(edu.degree, 'Degree not specified')}</strong>
                        <span className="credential-institution">{safeRender(edu.institution, 'Institution not specified')}</span>
                      </div>
                      <div className="credential-year">{safeRender(edu.year, 'Year not specified')}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Certifications Section (if available) */}
            {doctorProfile.certifications && doctorProfile.certifications.length > 0 && (
              <div className="profile-section">
                <h4>Certifications</h4>
                <div className="credentials-list">
                  {doctorProfile.certifications.map((cert, index) => (
                    <div key={index} className="credential-item">
                      <div className="credential-main">
                        <strong>{safeRender(cert.degree || cert.name, 'Certification not specified')}</strong>
                        <span className="credential-institution">{safeRender(cert.issuingAuthority || cert.authority, 'Authority not specified')}</span>
                      </div>
                      <div className="credential-year">{safeRender(cert.year, 'Year not specified')}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        
        <div className="doc-profile-modal-footer">
          <button type="button" className="doc-profile-primary-button" onClick={() => {
            setShowViewModal(false);
            setShowEditModal(true);
          }}>
            Edit Profile
          </button>
        </div>
      </div>
    </div>
  );
};

// Edit Modal Component - FULL WIDTH NO SIDEBAR LAYOUT
const EditPublicProfileModal = ({ 
  showEditModal, 
  setShowEditModal, 
  publicProfileData, 
  setPublicProfileData, 
  handlePublicProfileChange, 
  handleSavePublicProfile, 
  saving 
}) => {
  if (!showEditModal) return null;
  
  return (
    <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
      <div className="modal-content large-modal" onClick={(e) => e.stopPropagation()}>
        <div className="doc-profile-modal-header">
          <button className="doc-profile-modal-close" onClick={() => setShowEditModal(false)}>×</button>
        </div>
        
        <form onSubmit={handleSavePublicProfile}>
          <div className="doctor-profile-modal-body">
            
            {/* Doctor Header Section - EDITABLE */}
            <div className="doctor-header-section">
              <div className="doc-profile-doctor-photo">
                {publicProfileData.profilePicture ? (
                  <img src={publicProfileData.profilePicture} alt="Doctor" className="doctor-photo-img" />
                ) : (
                  <div className="doctor-photo-placeholder">
                    {publicProfileData.firstName?.charAt(0) || ''}{publicProfileData.lastName?.charAt(0) || ''}
                  </div>
                )}
              </div>
              
              <div className="doc-profile-doctor-info">
                <h3 className="doctor-name">
                  <input
                    type="text"
                    name="title"
                    value={publicProfileData.title}
                    onChange={handlePublicProfileChange}
                    placeholder="Title"
                    style={{ 
                      fontSize: '40px',
                      fontWeight: '600',
                      border: '2px dashed #A7D7C5',
                      borderRadius: '8px',
                      padding: '4px 8px',
                      width: '150px',
                      marginRight: '10px',
                      background: 'transparent'
                    }}
                  />
                  {publicProfileData.firstName} {publicProfileData.lastName}
                </h3>
                <p className="doctor-specialty">
                  <input
                    type="text"
                    name="specialty"
                    value={publicProfileData.specialty}
                    onChange={handlePublicProfileChange}
                    placeholder="Specialty *"
                    required
                    style={{ 
                      fontSize: '18px',
                      fontStyle: 'italic',
                      border: '2px dashed #A7D7C5',
                      borderRadius: '8px',
                      padding: '4px 8px',
                      width: '100%',
                      background: 'transparent'
                    }}
                  />
                </p>
              </div>

              {/* Bio Section - EDITABLE */}
              <div className="doctor-bio-section">
                <textarea
                  name="professionalBio"
                  value={publicProfileData.professionalBio}
                  onChange={handlePublicProfileChange}
                  placeholder="Write your professional biography..."
                  className="bio-text"
                  rows="4"
                  style={{
                    width: '100%',
                    fontSize: '14px',
                    padding: '10px',
                    border: '2px dashed #A7D7C5',
                    borderRadius: '8px',
                    fontFamily: "'IBM Plex Mono', monospace",
                    resize: 'vertical',
                    background: 'transparent'
                  }}
                />
              </div>
            </div>

            {/* Personal Information Section - EDITABLE */}
            <div className="profile-section" style={{ marginTop: '24px' }}>
              <h4>Personal Information</h4>
              <div className="info-grid">
                <div className="info-item">
                  <label>First Name:</label>
                  <span>{publicProfileData.firstName}</span>
                </div>
                <div className="info-item">
                  <label>Last Name:</label>
                  <span>{publicProfileData.lastName}</span>
                </div>
                <div className="info-item">
                  <label>Email Address:</label>
                  <span>{publicProfileData.email}</span>
                </div>
                <div className="info-item">
                  <label>Personal Contact Number:</label>
                  <input
                    type="tel"
                    name="personalContactNumber"
                    value={publicProfileData.personalContactNumber}
                    onChange={handlePublicProfileChange}
                    placeholder="Contact number"
                    style={{ 
                      border: '1px solid #A7D7C5',
                      padding: '10px',
                      borderRadius: '10px',
                      width: '100%',
                      fontFamily: "'IBM Plex Mono', monospace",
                      fontSize: '15px'
                    }}
                  />
                </div>
                <div className="info-item">
                  <label>Clinic Location:</label>
                  <input
                    type="text"
                    name="clinicAddress"
                    value={publicProfileData.clinicAddress}
                    onChange={handlePublicProfileChange}
                    placeholder="Clinic address"
                    style={{ 
                      border: '1px solid #A7D7C5',
                      padding: '10px',
                      borderRadius: '10px',
                      width: '100%',
                      fontFamily: "'IBM Plex Mono', monospace",
                      fontSize: '15px'
                    }}
                  />
                </div>
                <div className="info-item">
                  <label>Clinic Contact Number:</label>
                  <input
                    type="tel"
                    name="clinicContactNumber"
                    value={publicProfileData.clinicContactNumber}
                    onChange={handlePublicProfileChange}
                    placeholder="Clinic number"
                    style={{ 
                      border: '1px solid #A7D7C5',
                      padding: '10px',
                      borderRadius: '10px',
                      width: '100%',
                      fontFamily: "'IBM Plex Mono', monospace",
                      fontSize: '15px'
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Services Offered - FULL WIDTH */}
            <div className="profile-section" style={{ marginTop: '24px' }}>
              <h4>Services Offered</h4>
              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '12px',
                padding: '16px',
                background: '#F6FBF9',
                border: '1px solid #A7D7C5',
                borderRadius: '10px'
              }}>
                <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input
                    type="checkbox"
                    name="inPerson"
                    checked={publicProfileData.inPerson}
                    onChange={handlePublicProfileChange}
                    className="checkbox-input"
                    style={{ width: '20px', height: '20px', accentColor: '#548170' }}
                  />
                  <span style={{ fontSize: '15px', fontFamily: "'IBM Plex Mono', monospace" }}>
                    In-Person Consultations
                  </span>
                </label>
                
                <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input
                    type="checkbox"
                    name="telehealth"
                    checked={publicProfileData.telehealth}
                    onChange={handlePublicProfileChange}
                    className="checkbox-input"
                    style={{ width: '20px', height: '20px', accentColor: '#548170' }}
                  />
                  <span style={{ fontSize: '15px', fontFamily: "'IBM Plex Mono', monospace" }}>
                    Telehealth Services
                  </span>
                </label>

                <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input
                    type="checkbox"
                    name="emergencyAware"
                    checked={publicProfileData.emergencyAware}
                    onChange={handlePublicProfileChange}
                    className="checkbox-input"
                    style={{ width: '20px', height: '20px', accentColor: '#548170' }}
                  />
                  <span style={{ fontSize: '15px', fontFamily: "'IBM Plex Mono', monospace" }}>
                    Emergency Consultations
                  </span>
                </label>
              </div>
            </div>

            {/* Availability Section - FULL WIDTH */}
            <div className="profile-section" style={{ marginTop: '24px' }}>
              <h4 style={{ marginBottom: '20px' }}>Weekly Availability</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(day => (
                  <div 
                    key={day} 
                    style={{
                      background: publicProfileData.availability?.[day]?.available ? '#F6FBF9' : '#FAFAFA',
                      border: '1px solid #A7D7C5',
                      borderRadius: '10px',
                      padding: '16px',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <label style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '12px',
                      cursor: 'pointer',
                      marginBottom: publicProfileData.availability?.[day]?.available ? '12px' : '0'
                    }}>
                      <input
                        type="checkbox"
                        checked={publicProfileData.availability?.[day]?.available || false}
                        onChange={(e) => {
                          setPublicProfileData(prev => ({
                            ...prev,
                            availability: {
                              ...prev.availability,
                              [day]: {
                                ...prev.availability?.[day],
                                available: e.target.checked,
                                slots: prev.availability?.[day]?.slots || []
                              }
                            }
                          }));
                        }}
                        style={{
                          width: '20px',
                          height: '20px',
                          cursor: 'pointer',
                          accentColor: '#548170'
                        }}
                      />
                      <span style={{ 
                        fontWeight: '600',
                        fontSize: '16px',
                        textTransform: 'capitalize',
                        fontFamily: "'IBM Plex Mono', monospace",
                        color: publicProfileData.availability?.[day]?.available ? '#548170' : '#666'
                      }}>
                        {day}
                      </span>
                    </label>
                    
                    {publicProfileData.availability?.[day]?.available && (
                      <div style={{ 
                        paddingLeft: '32px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px'
                      }}>
                        {(publicProfileData.availability[day].slots || []).map((slot, index) => (
                          <div 
                            key={index} 
                            style={{ 
                              display: 'flex', 
                              alignItems: 'center',
                              gap: '10px',
                              background: 'white',
                              padding: '12px',
                              borderRadius: '8px',
                              border: '1px solid #E0E0E0'
                            }}
                          >
                            <input
                              type="time"
                              value={slot.startTime || ''}
                              onChange={(e) => {
                                setPublicProfileData(prev => {
                                  const newSlots = [...(prev.availability[day].slots || [])];
                                  newSlots[index] = { ...newSlots[index], startTime: e.target.value };
                                  return {
                                    ...prev,
                                    availability: {
                                      ...prev.availability,
                                      [day]: { ...prev.availability[day], slots: newSlots }
                                    }
                                  };
                                });
                              }}
                              style={{
                                padding: '8px 12px',
                                border: '1px solid #CCC',
                                borderRadius: '6px',
                                fontSize: '14px',
                                fontFamily: "'IBM Plex Mono', monospace",
                                width: '120px'
                              }}
                            />
                            <span style={{ 
                              color: '#666',
                              fontWeight: '500',
                              fontSize: '14px'
                            }}>to</span>
                            <input
                              type="time"
                              value={slot.endTime || ''}
                              onChange={(e) => {
                                setPublicProfileData(prev => {
                                  const newSlots = [...(prev.availability[day].slots || [])];
                                  newSlots[index] = { ...newSlots[index], endTime: e.target.value };
                                  return {
                                    ...prev,
                                    availability: {
                                      ...prev.availability,
                                      [day]: { ...prev.availability[day], slots: newSlots }
                                    }
                                  };
                                });
                              }}
                              style={{
                                padding: '8px 12px',
                                border: '1px solid #CCC',
                                borderRadius: '6px',
                                fontSize: '14px',
                                fontFamily: "'IBM Plex Mono', monospace",
                                width: '120px'
                              }}
                            />
                            <button
                              type="button"
                              onClick={() => {
                                setPublicProfileData(prev => {
                                  const newSlots = [...(prev.availability[day].slots || [])];
                                  newSlots.splice(index, 1);
                                  return {
                                    ...prev,
                                    availability: {
                                      ...prev.availability,
                                      [day]: { ...prev.availability[day], slots: newSlots }
                                    }
                                  };
                                });
                              }}
                              style={{
                                background: '#FF6B6B',
                                color: 'white',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '13px',
                                fontWeight: '500',
                                transition: 'background 0.2s ease',
                                marginLeft: 'auto'
                              }}
                              onMouseOver={(e) => e.target.style.background = '#FF5252'}
                              onMouseOut={(e) => e.target.style.background = '#FF6B6B'}
                            >
                              Remove
                            </button>
                          </div>
                        ))}
                        
                        <button
                          type="button"
                          onClick={() => {
                            setPublicProfileData(prev => ({
                              ...prev,
                              availability: {
                                ...prev.availability,
                                [day]: {
                                  ...prev.availability[day],
                                  slots: [
                                    ...(prev.availability[day]?.slots || []),
                                    { startTime: '', endTime: '' }
                                  ]
                                }
                              }
                            }));
                          }}
                          style={{
                            background: '#548170',
                            color: 'white',
                            border: 'none',
                            padding: '10px 16px',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '600',
                            transition: 'background 0.2s ease',
                            width: 'fit-content'
                          }}
                          onMouseOver={(e) => e.target.style.background = '#45685A'}
                          onMouseOut={(e) => e.target.style.background = '#548170'}
                        >
                          + Add Time Slot
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Education Section (if available) */}
            {publicProfileData.education && publicProfileData.education.length > 0 && (
              <div className="profile-section" style={{ marginTop: '24px' }}>
                <h4>Education</h4>
                <div className="credentials-list">
                  {publicProfileData.education.map((edu, index) => (
                    <div key={index} className="credential-item">
                      <div className="credential-main">
                        <strong>{edu.degree || 'Degree not specified'}</strong>
                        <span className="credential-institution">{edu.institution || 'Institution not specified'}</span>
                      </div>
                      <div className="credential-year">{edu.year || 'Year not specified'}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Certifications Section (if available) */}
            {publicProfileData.certifications && publicProfileData.certifications.length > 0 && (
              <div className="profile-section" style={{ marginTop: '24px' }}>
                <h4>Certifications</h4>
                <div className="credentials-list">
                  {publicProfileData.certifications.map((cert, index) => (
                    <div key={index} className="credential-item">
                      <div className="credential-main">
                        <strong>{cert.degree || cert.name || 'Certification not specified'}</strong>
                        <span className="credential-institution">{cert.issuingAuthority || cert.authority || 'Authority not specified'}</span>
                      </div>
                      <div className="credential-year">{cert.year || 'Year not specified'}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

          </div>
          
          <div className="doc-profile-modal-footer">
            <button type="button" className="doc-profile-secondary-button" onClick={() => setShowEditModal(false)}>
              Cancel
            </button>
            <button type="submit" className="doc-profile-primary-button" disabled={saving}>
              {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const DoctorProfile = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('edit-profile');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  
  // Profile picture upload states
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  
  const [doctorProfile, setDoctorProfile] = useState({
    firstName: '',
    lastName: '',
    title: '',
    email: '',
    profilePicture: null
  });

  // Form state for editing - Only essential fields
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    title: ''
  });

  const [profileImagePreview, setProfileImagePreview] = useState(null);

  // 🆕 NEW: Change Email/Password states - moved to component level
  const [emailData, setEmailData] = useState({
    currentEmail: '',
    newEmail: '',
    password: ''
  });

  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false,
    emailPassword: false
  });

  const [changingEmail, setChangingEmail] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);
  const [activeTab, setActiveTab] = useState('email'); // 'email' or 'password'

  // Public Profile modal states
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  // Public profile form data (separate from main profile editing)
  const [publicProfileData, setPublicProfileData] = useState({
    // Professional Information
    title: '',
    firstName: '',
    lastName: '',
    specialty: '',
    yearsOfPractice: '',
    experience: '',
    areasOfExpertise: '',
    
    // Clinic Information
    clinicName: '',
    clinicAddress: '',
    personalContactNumber: '',
    clinicContactNumber: '',
    
    // Services & Availability
    consultationFee: '',
    inPerson: false,
    telehealth: false,
    emergencyAware: false,
    
    // Professional Background
    licenseNumber: '',
    licenseIssuingAuthority: '',
    
    // Bio/Description
    professionalBio: '',
    
    // Education & Certifications (if available)
    education: [],
    certifications: [],
    licenses: []
  });

  // Load doctor profile on component mount
  useEffect(() => {
    loadDoctorProfile();
  }, []);

  // Load public profile data when doctorProfile changes
 useEffect(() => {
  if (doctorProfile && Object.keys(doctorProfile).length > 0) {
    console.log('🔄 Updating public profile data from doctorProfile:', doctorProfile);
    
    setPublicProfileData({
      // Basic Information - with fallbacks like admin code
      title: doctorProfile.title || '',
      firstName: doctorProfile.firstName || '',
      lastName: doctorProfile.lastName || '',
      middleName: doctorProfile.middleName || '',
      nickname: doctorProfile.nickname || '',
      
      // Professional Information - with field variations like admin
      specialty: doctorProfile.specialty || doctorProfile.specialization || '',
      yearsOfPractice: doctorProfile.yearsOfPractice || doctorProfile.yearsOfExperience || doctorProfile.experience || '',
      experience: doctorProfile.experience || doctorProfile.yearsOfExperience || doctorProfile.yearsOfPractice || '',
      areasOfExpertise: doctorProfile.areasOfExpertise || '',
      
      // Clinic Information - with field variations
      clinicName: doctorProfile.clinicName || '',
      clinicAddress: doctorProfile.clinicAddress || doctorProfile.clinicLocation || '',
      personalContactNumber: doctorProfile.personalContactNumber || doctorProfile.phoneNumber || '',
      clinicContactNumber: doctorProfile.clinicContactNumber || '',
      
      // Services & Availability
      consultationFee: doctorProfile.consultationFee || '',
      inPerson: doctorProfile.inPerson || doctorProfile.appointmentTypes?.inPerson || false,
      telehealth: doctorProfile.telehealth || doctorProfile.appointmentTypes?.telehealth || false,
      emergencyAware: doctorProfile.emergencyAware || false,
      
      // License & Professional Background
      licenseNumber: doctorProfile.licenseNumber || '',
      licenseIssuingAuthority: doctorProfile.licenseIssuingAuthority || '',
      
      // Bio/Description
      professionalBio: doctorProfile.professionalBio || doctorProfile.bio || '',
      
      // Complex Arrays - Handle safely like admin code
      education: Array.isArray(doctorProfile.education) ? doctorProfile.education : [],
      certifications: Array.isArray(doctorProfile.certifications) ? doctorProfile.certifications : [],
      licenses: Array.isArray(doctorProfile.licenses) ? doctorProfile.licenses : [],
      
      // Availability Object - Handle safely
      availability: (doctorProfile.availability && typeof doctorProfile.availability === 'object') ? 
        doctorProfile.availability : {},
      
      // Document URLs
      licenseDocumentUrl: doctorProfile.licenseDocumentUrl || '',
      educationCertificateUrl: doctorProfile.educationCertificateUrl || '',
      additionalDocumentUrls: Array.isArray(doctorProfile.additionalDocumentUrls) ? 
        doctorProfile.additionalDocumentUrls : [],
      
      // Payment Methods - Handle complex nested object safely
      paymentMethods: (doctorProfile.paymentMethods && typeof doctorProfile.paymentMethods === 'object') ? {
        gcash: {
          enabled: doctorProfile.paymentMethods.gcash?.enabled || false,
          qrCode: doctorProfile.paymentMethods.gcash?.qrCode || '',
          accountNumber: doctorProfile.paymentMethods.gcash?.accountNumber || '',
          accountName: doctorProfile.paymentMethods.gcash?.accountName || ''
        },
        paymaya: {
          enabled: doctorProfile.paymentMethods.paymaya?.enabled || false,
          qrCode: doctorProfile.paymentMethods.paymaya?.qrCode || '',
          accountNumber: doctorProfile.paymentMethods.paymaya?.accountNumber || '',
          accountName: doctorProfile.paymentMethods.paymaya?.accountName || ''
        },
        bankAccounts: Array.isArray(doctorProfile.paymentMethods.bankAccounts) ? 
          doctorProfile.paymentMethods.bankAccounts : []
      } : {
        gcash: { enabled: false, qrCode: '', accountNumber: '', accountName: '' },
        paymaya: { enabled: false, qrCode: '', accountNumber: '', accountName: '' },
        bankAccounts: []
      },
      
      // Additional fields
      occupation: doctorProfile.occupation || '',
      location: doctorProfile.location || '',
      
      // Verification info
      verificationStatus: doctorProfile.verificationStatus || 'pending',
      isActive: doctorProfile.isActive || false,
      isEmailVerified: doctorProfile.isEmailVerified || false,
      
      // Profile picture
      profilePicture: doctorProfile.profilePicture || null
    });
    
    console.log('✅ Public profile data updated with field variations');
  }
}, [doctorProfile]);

  const loadDoctorProfile = async () => {
  try {
    setLoading(true);
    console.log('🔍 Loading doctor profile...');
    
    const response = await doctorService.getProfile();
    console.log('✅ Profile loaded:', response);
    
    let profileData = {};
    
    // Handle different response structures
    if (response.success && response.data) {
      profileData = response.data;
    } else if (response.data) {
      profileData = response.data;
    } else {
      profileData = response;
    }
    
    // 🔍 DEBUG: Log ALL available fields
    console.log('🔍 ALL PROFILE FIELDS AVAILABLE:');
    console.log('Field names:', Object.keys(profileData));
    console.log('Field count:', Object.keys(profileData).length);
    
    // Check specific important fields
    console.log('🔍 SPECIFIC FIELD CHECK:');
    console.log('Basic Info:', {
      firstName: profileData.firstName,
      lastName: profileData.lastName,
      email: profileData.email,
      title: profileData.title,
      middleName: profileData.middleName,
      nickname: profileData.nickname
    });
    
    console.log('Professional Info:', {
      specialty: profileData.specialty,
      licenseNumber: profileData.licenseNumber,
      licenseIssuingAuthority: profileData.licenseIssuingAuthority,
      yearsOfPractice: profileData.yearsOfPractice,
      experience: profileData.experience,
      areasOfExpertise: profileData.areasOfExpertise,
      consultationFee: profileData.consultationFee
    });
    
    console.log('Clinic Info:', {
      clinicName: profileData.clinicName,
      clinicAddress: profileData.clinicAddress,
      personalContactNumber: profileData.personalContactNumber,
      clinicContactNumber: profileData.clinicContactNumber
    });
    
    console.log('Services:', {
      inPerson: profileData.inPerson,
      telehealth: profileData.telehealth,
      emergencyAware: profileData.emergencyAware,
      appointmentTypes: profileData.appointmentTypes
    });
    
    console.log('Complex Objects:', {
      availability: profileData.availability,
      education: profileData.education,
      licenses: profileData.licenses,
      certifications: profileData.certifications,
      paymentMethods: profileData.paymentMethods
    });
    
    console.log('Documents:', {
      profilePicture: profileData.profilePicture,
      licenseDocumentUrl: profileData.licenseDocumentUrl,
      educationCertificateUrl: profileData.educationCertificateUrl,
      additionalDocumentUrls: profileData.additionalDocumentUrls
    });
    
    console.log('Verification:', {
      verificationStatus: profileData.verificationStatus,
      verificationDate: profileData.verificationDate,
      verificationNotes: profileData.verificationNotes,
      isActive: profileData.isActive,
      isEmailVerified: profileData.isEmailVerified
    });
    
    // Set the COMPLETE doctor profile data
    console.log('🔧 Setting complete profile data...');
    setDoctorProfile(profileData);
    
    // Set form data for basic editing (only essential fields for the main edit form)
    const basicFormData = {
      firstName: profileData.firstName || '',
      lastName: profileData.lastName || '',
      title: profileData.title || '',
      middleName: profileData.middleName || '',
      nickname: profileData.nickname || ''
    };
    
    console.log('📝 Setting basic form data:', basicFormData);
    setFormData(basicFormData);
    
    // Set current email for change email form
    setEmailData(prev => ({
      ...prev,
      currentEmail: profileData.email || ''
    }));
    
    // Set profile picture preview
    if (profileData.profilePicture) {
      setProfileImagePreview(profileData.profilePicture);
    }
    
    // Final verification log
    console.log('✅ Profile data set successfully:', {
      totalFieldsSet: Object.keys(profileData).length,
      hasVerificationStatus: !!profileData.verificationStatus,
      hasSpecialty: !!profileData.specialty,
      hasLicenseNumber: !!profileData.licenseNumber,
      hasClinicName: !!profileData.clinicName,
      hasConsultationFee: profileData.consultationFee !== undefined,
      hasAvailability: !!profileData.availability,
      hasEducation: !!(profileData.education && profileData.education.length > 0),
      hasCertifications: !!(profileData.certifications && profileData.certifications.length > 0),
      hasPaymentMethods: !!profileData.paymentMethods,
      profilePictureSet: !!profileData.profilePicture
    });
    
  } catch (error) {
    console.error('❌ Error loading doctor profile:', error);
    
    // Enhanced error logging
    if (error.response) {
      console.error('Server Error Details:');
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
      console.error('Headers:', error.response.headers);
      console.error('Request URL:', error.response.config?.url);
    } else if (error.request) {
      console.error('Request Error - No response received');
      console.error('Request details:', error.request);
    } else {
      console.error('Setup Error:', error.message);
    }
    
    toast.error('Failed to load profile information');
  } finally {
    setLoading(false);
  }
};

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Profile picture change handler with automatic upload
  const handleProfileImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        toast.error('Please select a valid image file');
        return;
      }
      
      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error('Image size should be less than 5MB');
        return;
      }
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setProfileImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
      
      // Store the file for upload
      setSelectedFile(file);
      
      // Automatically upload the profile picture
      await uploadProfilePicture(file);
    }
  };

  // Upload profile picture function
  const uploadProfilePicture = async (file) => {
    try {
      setUploading(true);
      console.log('📤 Uploading profile picture...');
      
      // Create FormData
      const formData = new FormData();
      formData.append('profilePicture', file);
      
      // Upload to server
      const response = await doctorService.uploadProfilePicture(formData);
      console.log('✅ Profile picture uploaded:', response);
      
      if (response.success) {
        // Update the doctor profile state with new picture URL
        setDoctorProfile(prev => ({
          ...prev,
          profilePicture: response.data.profilePicture
        }));
        
        // Update preview with the actual uploaded URL
        setProfileImagePreview(response.data.profilePicture);
        
        // Dispatch custom event to update layout sidebar
        window.dispatchEvent(new CustomEvent('profilePictureUpdated', {
          detail: { profilePicture: response.data.profilePicture }
        }));
        
        toast.success('Profile picture updated successfully!');
      }
      
    } catch (error) {
      console.error('❌ Error uploading profile picture:', error);
      
      // Reset preview on error
      setProfileImagePreview(doctorProfile.profilePicture || null);
      setSelectedFile(null);
      
      const errorMessage = error.response?.data?.message || error.message || 'Failed to upload profile picture';
      toast.error(errorMessage);
    } finally {
      setUploading(false);
    }
  };

  // Delete profile picture function
  const deleteProfilePicture = async () => {
    try {
      setUploading(true);
      console.log('🗑️ Deleting profile picture...');
      
      const response = await doctorService.deleteProfilePicture();
      console.log('✅ Profile picture deleted:', response);
      
      if (response.success) {
        // Clear the profile picture
        setDoctorProfile(prev => ({
          ...prev,
          profilePicture: null
        }));
        setProfileImagePreview(null);
        setSelectedFile(null);
        
        // Dispatch event to update layout sidebar
        window.dispatchEvent(new CustomEvent('profilePictureUpdated', {
          detail: { profilePicture: null }
        }));
        
        toast.success('Profile picture deleted successfully!');
      }
      
    } catch (error) {
      console.error('❌ Error deleting profile picture:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to delete profile picture';
      toast.error(errorMessage);
    } finally {
      setUploading(false);
    }
  };

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    
    try {
      setSaving(true);
      console.log('💾 Saving doctor profile...');
      
      // Validate required fields - Only essential ones
      if (!formData.firstName || !formData.lastName) {
        toast.error('Please fill in all required fields (First Name and Last Name)');
        return;
      }
      
      // Prepare data for submission - Only essential fields
      const updateData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        title: formData.title || ''
      };
      
      console.log('📤 Sending update data:', updateData);
      
      const response = await doctorService.updateProfile(updateData);
      console.log('✅ Profile updated:', response);
      
      // Update local state
      setDoctorProfile(prev => ({
        ...prev,
        ...formData
      }));
      
      toast.success('Profile updated successfully!');
      
    } catch (error) {
      console.error('❌ Error updating profile:', error);
      
      // Show specific error message if available
      const errorMessage = error.response?.data?.message || error.message || 'Failed to update profile';
      toast.error(errorMessage);
    } finally {
      setSaving(false);
    }
  };

  // Password validation function
  const validatePassword = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    const errors = [];
    if (password.length < minLength) {
      errors.push(`Password must be at least ${minLength} characters long`);
    }
    if (!hasUpperCase) {
      errors.push('Password must contain at least one uppercase letter');
    }
    if (!hasLowerCase) {
      errors.push('Password must contain at least one lowercase letter');
    }
    if (!hasNumbers) {
      errors.push('Password must contain at least one number');
    }
    if (!hasSpecialChar) {
      errors.push('Password must contain at least one special character');
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  };

  // Email validation
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Handle email change
  const handleEmailChange = async (e) => {
  e.preventDefault();
  
  try {
    setChangingEmail(true);

    // Validate email format
    if (!validateEmail(emailData.newEmail)) {
      toast.error('Please enter a valid email address');
      return;
    }

    // Check if new email is different
    if (emailData.newEmail === emailData.currentEmail) {
      toast.error('New email must be different from current email');
      return;
    }

    // Validate current password is provided
    if (!emailData.password) {
      toast.error('Please enter your current password to confirm the change');
      return;
    }

    console.log('🔄 Changing email...');
    
    // ✅ FIXED: Pass a single object instead of three separate parameters
    const response = await doctorService.changeEmail({
      currentEmail: emailData.currentEmail,
      newEmail: emailData.newEmail,
      password: emailData.password
    });

    if (response.success) {
      // Update local state
      setDoctorProfile(prev => ({
        ...prev,
        email: emailData.newEmail
      }));
      
      setEmailData(prev => ({
        ...prev,
        currentEmail: emailData.newEmail,
        newEmail: '',
        password: ''
      }));

      toast.success('Email address updated successfully!');
    }

  } catch (error) {
    console.error('❌ Error changing email:', error);
    const errorMessage = error.response?.data?.message || error.message || 'Failed to change email';
    toast.error(errorMessage);
  } finally {
    setChangingEmail(false);
  }
};

  // Handle password change
  const handlePasswordChange = async (e) => {
  e.preventDefault();
  
  try {
    setChangingPassword(true);

    // Validate current password is provided
    if (!passwordData.currentPassword) {
      toast.error('Please enter your current password');
      return;
    }

    // Validate new password
    const passwordValidation = validatePassword(passwordData.newPassword);
    if (!passwordValidation.isValid) {
      toast.error(passwordValidation.errors[0]);
      return;
    }

    // Check password confirmation
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast.error('New passwords do not match');
      return;
    }

    // Check if new password is different from current
    if (passwordData.currentPassword === passwordData.newPassword) {
      toast.error('New password must be different from current password');
      return;
    }

    console.log('🔄 Changing password...');
    
    // ✅ FIXED: Pass a single object instead of three separate parameters
    const response = await doctorService.changePassword({
      currentPassword: passwordData.currentPassword,
      newPassword: passwordData.newPassword,
      confirmPassword: passwordData.confirmPassword
    });

    if (response.success) {
      // Clear form
      setPasswordData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });

      toast.success('Password updated successfully!');
    }

  } catch (error) {
    console.error('❌ Error changing password:', error);
    const errorMessage = error.response?.data?.message || error.message || 'Failed to change password';
    toast.error(errorMessage);
  } finally {
    setChangingPassword(false);
  }
};

// Handle public profile form input changes
  const handlePublicProfileChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    setPublicProfileData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Save public profile changes
  const handleSavePublicProfile = async (e) => {
    e.preventDefault();
    
    try {
      setSaving(true);
      console.log('💾 Saving public profile...');
      
      // Prepare update data - only send fields that have changed
      const updateData = { ...publicProfileData };
      
      console.log('📤 Sending public profile update:', updateData);
      
      const response = await doctorService.updateProfile(updateData);
      console.log('✅ Public profile updated:', response);
      
      // Update local doctorProfile state
      setDoctorProfile(prev => ({
        ...prev,
        ...publicProfileData
      }));
      
      toast.success('Public profile updated successfully!');
      setShowEditModal(false);
      
    } catch (error) {
      console.error('❌ Error updating public profile:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to update public profile';
      toast.error(errorMessage);
    } finally {
      setSaving(false);
    }
  };

  // 🆕 FIXED: Change Email or Password Component (no useState hooks)
  const renderChangeEmailPassword = () => {
    return (
      <div className="profile-content">
        <div className="content-header">
          <h2>Change Email or Password</h2>
          <div className="tools-section">
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="change-email-pass-body">
        <div className="change-tabs">
          <button 
            className={`tab-button ${activeTab === 'email' ? 'active' : ''}`}
            onClick={() => setActiveTab('email')}
          >
            Change Email
          </button>
          <button 
            className={`tab-button ${activeTab === 'password' ? 'active' : ''}`}
            onClick={() => setActiveTab('password')}
          >
            Change Password
          </button>
        </div>

        {/* Email Change Form */}
        {activeTab === 'email' && (
          <form onSubmit={handleEmailChange} className="email-change-form">
            <div className="form-section">
              <div className="form-group">
                <label htmlFor="currentEmail">Current Email Address</label>
                <input
                  type="email"
                  id="currentEmail"
                  value={emailData.currentEmail}
                  readOnly
                  className="form-input readonly"
                />
              </div>

              <div className="form-group">
                <label htmlFor="newEmail">New Email Address</label>
                <input
                  type="email"
                  id="newEmail"
                  value={emailData.newEmail}
                  onChange={(e) => setEmailData(prev => ({ ...prev, newEmail: e.target.value }))}
                  required
                  className="form-input"
                  placeholder="Enter your new email address"
                />
              </div>

              <div className="form-group">
                <label htmlFor="emailPassword">Current Password</label>
                <div className="password-input-container">
                  <input
                    type={showPasswords.emailPassword ? 'text' : 'password'}
                    id="emailPassword"
                    value={emailData.password}
                    onChange={(e) => setEmailData(prev => ({ ...prev, password: e.target.value }))}
                    required
                    className="form-input"
                    placeholder="Enter your current password to confirm"
                  />
                  <button 
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPasswords(prev => ({ ...prev, emailPassword: !prev.emailPassword }))}
                  >
                    <img 
                        src={showPasswords.emailPassword ? EyeOpen : EyeClosed} 
                        alt="toggle password visibility"
                        style={{ width: '20px', height: '20px' }} // adjust size as needed
                      />
                  </button>
                </div>
              </div>

              <div className="form-actions">
                <button 
                  type="submit" 
                  className="change-email-pass-save-button"
                  disabled={changingEmail || !emailData.newEmail || !emailData.password}
                >
                  {changingEmail ? 'Updating Email...' : 'Update Email'}
                </button>
              </div>
            </div>
          </form>
        )}

        {/* Password Change Form */}
        {activeTab === 'password' && (
          <form onSubmit={handlePasswordChange} className="password-change-form">
            <div className="form-section">
              
              <div className="form-group">
                <label htmlFor="currentPassword">Current Password</label>
                <div className="password-input-container">
                  <input
                    type={showPasswords.current ? 'text' : 'password'}
                    id="currentPassword"
                    value={passwordData.currentPassword}
                    onChange={(e) => setPasswordData(prev => ({ ...prev, currentPassword: e.target.value }))}
                    required
                    className="form-input"
                    placeholder="Enter your current password"
                  />
                  <button 
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPasswords(prev => ({ ...prev, current: !prev.current }))}
                  >
                   <img 
                          src={showPasswords.emailPassword ? EyeOpen : EyeClosed} 
                          alt="toggle password visibility"
                          style={{ width: '20px', height: '20px' }}
                        />
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="newPassword">New Password</label>
                <div className="password-input-container">
                  <input
                    type={showPasswords.new ? 'text' : 'password'}
                    id="newPassword"
                    value={passwordData.newPassword}
                    onChange={(e) => setPasswordData(prev => ({ ...prev, newPassword: e.target.value }))}
                    required
                    className="form-input"
                    placeholder="Enter your new password"
                  />
                  <button 
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPasswords(prev => ({ ...prev, new: !prev.new }))}
                  >
                    <img 
                          src={showPasswords.emailPassword ? EyeOpen : EyeClosed} 
                          alt="toggle password visibility"
                          style={{ width: '20px', height: '20px' }}
                        />
                  </button>
                </div>
                {passwordData.newPassword && (
                  <div className="password-requirements">
                    <p className="requirements-title">Password Requirements:</p>
                    <ul className="requirements-list">
                      <li className={passwordData.newPassword.length >= 8 ? 'valid' : 'invalid'}>
                        At least 8 characters long
                      </li>
                      <li className={/[A-Z]/.test(passwordData.newPassword) ? 'valid' : 'invalid'}>
                        One uppercase letter
                      </li>
                      <li className={/[a-z]/.test(passwordData.newPassword) ? 'valid' : 'invalid'}>
                        One lowercase letter
                      </li>
                      <li className={/\d/.test(passwordData.newPassword) ? 'valid' : 'invalid'}>
                        One number
                      </li>
                      <li className={/[!@#$%^&*(),.?":{}|<>]/.test(passwordData.newPassword) ? 'valid' : 'invalid'}>
                        One special character
                      </li>
                    </ul>
                  </div>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm New Password</label>
                <div className="password-input-container">
                  <input
                    type={showPasswords.confirm ? 'text' : 'password'}
                    id="confirmPassword"
                    value={passwordData.confirmPassword}
                    onChange={(e) => setPasswordData(prev => ({ ...prev, confirmPassword: e.target.value }))}
                    required
                    className="form-input"
                    placeholder="Confirm your new password"
                  />
                  <button 
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPasswords(prev => ({ ...prev, confirm: !prev.confirm }))}
                  >
                    <img 
                          src={showPasswords.emailPassword ? EyeOpen : EyeClosed} 
                          alt="toggle password visibility"
                          style={{ width: '20px', height: '20px' }}
                        />
                  </button>
                </div>
                {passwordData.confirmPassword && passwordData.newPassword && (
                  <div className={`password-match ${passwordData.newPassword === passwordData.confirmPassword ? 'valid' : 'invalid'}`}>
                    {passwordData.newPassword === passwordData.confirmPassword ? 
                      '✓ Passwords match' : 
                      '✗ Passwords do not match'}
                  </div>
                )}
              </div>

              <div className="form-actions">
                <button 
                  type="submit" 
                  className="change-email-pass-save-button"
                  disabled={
                    changingPassword || 
                    !passwordData.currentPassword || 
                    !passwordData.newPassword || 
                    !passwordData.confirmPassword ||
                    passwordData.newPassword !== passwordData.confirmPassword ||
                    !validatePassword(passwordData.newPassword).isValid
                  }
                >
                  {changingPassword ? 'Updating Password...' : 'Update Password'}
                </button>
              </div>
            </div>
          </form>
        )}
        </div>
      </div>
    );
  };


// 🆕 REPLACE THE ENTIRE renderDoctorApplication FUNCTION WITH THIS:
// COMPLETE renderDoctorApplication function
const renderDoctorApplication = () => {
  return (
    <div className="profile-content">
      <div className="content-header">
        <h2>My Doctor Application</h2>
        <div className="tools-section">
          <button className="tools-button">
            <img src={settingsIcon} alt="Tools" />
          </button>
        </div>
      </div>

      <div className="application-overview">
        {/* PERSONAL INFORMATION SECTION - 2 COLUMN LAYOUT */}
        <div className="form-section">
          <h3>Personal Information</h3>
          <div className="two-column-grid">
            <div className="column">
              <div className="info-item">
                <label>First Name</label>
                <span>{safeRender(doctorProfile.firstName)}</span>
              </div>
              <div className="info-item">
                <label>Email Address</label>
                <span>{safeRender(doctorProfile.email)}</span>
              </div>
              <div className="info-item">
                <label>Clinic Location</label>
                <span>{safeRender(doctorProfile.clinicAddress || doctorProfile.clinicLocation)}</span>
              </div>
            </div>
            
            <div className="column">
              <div className="info-item">
                <label>Last Name</label>
                <span>{safeRender(doctorProfile.lastName)}</span>
              </div>
              <div className="info-item">
                <label>Personal Contact Number</label>
                <span>{safeRender(doctorProfile.personalContactNumber || doctorProfile.phoneNumber)}</span>
              </div>
              <div className="info-item">
                <label>Clinic Contact Number</label>
                <span>{safeRender(doctorProfile.clinicContactNumber)}</span>
              </div>
            </div>
          </div>
        </div>

        {/* PERSONAL INFORMATION SECTION - 2 COLUMN LAYOUT */}
        <div className="form-section">
          <h3>Personal Information</h3>
          <div className="two-column-grid">
            <div className="column">
              <div className="info-item">
                <label>First Name</label>
                <span>{safeRender(doctorProfile.firstName)}</span>
              </div>
              <div className="info-item">
                <label>Email Address</label>
                <span>{safeRender(doctorProfile.email)}</span>
              </div>
              <div className="info-item">
                <label>Clinic Location</label>
                <span>{safeRender(doctorProfile.clinicAddress || doctorProfile.clinicLocation)}</span>
              </div>
            </div>
            
            <div className="column">
              <div className="info-item">
                <label>Last Name</label>
                <span>{safeRender(doctorProfile.lastName)}</span>
              </div>
              <div className="info-item">
                <label>Personal Contact Number</label>
                <span>{safeRender(doctorProfile.personalContactNumber || doctorProfile.phoneNumber)}</span>
              </div>
              <div className="info-item">
                <label>Clinic Contact Number</label>
                <span>{safeRender(doctorProfile.clinicContactNumber)}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="form-section">
  <h3>Availability</h3>
  {(() => {
    const hasAvailability = doctorProfile.availability && 
                            typeof doctorProfile.availability === 'object' &&
                            Object.keys(doctorProfile.availability).length > 0;
    
    if (!hasAvailability) {
      return (
        <div className="no-data">
          <p>No availability schedule set</p>
        </div>
      );
    }
    
    return (
      <div className="availability-list">
        {Object.entries(doctorProfile.availability).map(([day, schedule]) => {
          if (!schedule.available || !schedule.slots || schedule.slots.length === 0) {
            return null;
          }
          
          return (
            <div key={day} className="availability-item">
              <span className="day-label">{day.charAt(0).toUpperCase() + day.slice(1)}</span>
              <span className="separator">|</span>
              <span className="time-range">
                {schedule.slots.map((slot, index) => (
                  <span key={index}>
                    {slot.startTime} to {slot.endTime}
                    {index < schedule.slots.length - 1 && ' | '}
                  </span>
                ))}
              </span>
            </div>
          );
        })}
      </div>
    );
  })()}
</div>


<div className="form-section">
  <h3>Appointment Types</h3>
  <div className="appointment-types-box">
    {doctorProfile.inPerson && <span>In-person</span>}
    {doctorProfile.inPerson && (doctorProfile.telehealth || doctorProfile.emergencyAware) && <span>, </span>}
    {doctorProfile.telehealth && <span>Telehealth</span>}
    {doctorProfile.telehealth && doctorProfile.emergencyAware && <span>, </span>}
    {doctorProfile.emergencyAware && <span>Emergency</span>}
    {!doctorProfile.inPerson && !doctorProfile.telehealth && !doctorProfile.emergencyAware && (
      <span>No appointment types set</span>
    )}
  </div>
</div>

        {/* CREDENTIALS SECTION */}
        <div className="form-section">
          <h3>Credentials</h3>
          
          {/* Education */}
          {(doctorProfile.education && doctorProfile.education.length > 0) ? (
            <div className="credentials-subsection">
              <h4>Education</h4>
              <div className="credentials-list">
                {doctorProfile.education.map((edu, index) => (
                  <div key={index} className="credential-item">
                    <div className="credential-main">
                      <strong>{safeRender(edu.degree, 'Degree not specified')}</strong>
                      <span className="credential-institution">{safeRender(edu.institution, 'Institution not specified')}</span>
                    </div>
                    <div className="credential-year">{safeRender(edu.year, 'Year not specified')}</div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="no-data">
              <p>No education records available</p>
            </div>
          )}

          {/* Professional Licenses */}
          {(doctorProfile.licenses && doctorProfile.licenses.length > 0) && (
            <div className="credentials-subsection">
              <h4>Professional Licenses</h4>
              <div className="credentials-list">
                {doctorProfile.licenses.map((license, index) => (
                  <div key={index} className="credential-item">
                    <div className="credential-main">
                      <strong>{safeRender(license.degree)}</strong>
                      <span className="credential-number">License: {safeRender(license.licenseNumber)}</span>
                    </div>
                    <div className="credential-expiry">Expires: {safeRender(license.expirationDate)}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Certifications */}
          {(doctorProfile.certifications && doctorProfile.certifications.length > 0) && (
            <div className="credentials-subsection">
              <h4>Certifications</h4>
              <div className="credentials-list">
                {doctorProfile.certifications.map((cert, index) => (
                  <div key={index} className="credential-item">
                    <div className="credential-main">
                      <strong>{safeRender(cert.degree || cert.name, 'Certification not specified')}</strong>
                      <span className="credential-authority">{safeRender(cert.issuingAuthority || cert.authority, 'Authority not specified')}</span>
                    </div>
                    <div className="credential-year">{safeRender(cert.year, 'Year not specified')}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="form-section">
          <div className="application-actions">
            {doctorProfile.verificationStatus === 'pending' && (
              <div className="info-message">
                <h4>⏳ Application Under Review</h4>
                <p>Your application is currently being reviewed by our admin team. You will receive an email notification once the review is complete.</p>
              </div>
            )}
            
            {doctorProfile.verificationStatus === 'rejected' && (
              <div className="action-buttons">
                <button className="secondary-button" onClick={() => alert('Contact support feature coming soon')}>
                  Contact Support
                </button>
                <button className="primary-button" onClick={() => alert('Resubmit application feature coming soon')}>
                  Resubmit Application
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

  const renderSidebarMenu = () => {
    const menuItems = [
      { id: 'edit-profile', label: 'Edit Profile', icon: editIcon },
      { id: 'change-password', label: 'Change Email or Password', icon: keyIcon },
      { id: 'doctor-application', label: 'My Doctor Application', icon: profileIcon },
      { id: 'public-profile', label: 'Public Profile', icon: settingsIcon },
    ];

    return (
      <div className="profile-sidebar">
        <div className="sidebar-menu">
          {menuItems.map(item => (
            <button
              key={item.id}
              className={`sidebar-menu-item ${activeSection === item.id ? 'active' : ''}`}
              onClick={() => setActiveSection(item.id)}
            >
              <div className="icon-container">
              <img src={item.icon} alt={item.label} className="menu-icon" /> </div>
              <span className="menu-label">{item.label}</span>
              <span className="menu-arrow">›</span>
            </button>
          ))}
        </div>
        
        <div className="sidebar-footer">
          <button className="logout-button" onClick={() => navigate('/login')}>
            <img src={logoutIcon} alt="Logout" className="logout-icon" />
            <span>Logout</span>
          </button>
        </div>
        </div>
    );
  };

  // Updated renderEditProfile function with unique CSS class names
const renderEditProfile = () => {
  return (
    <div className="profile-content">
      <div className="content-header">
        <h2>Edit Profile</h2>
        <div className="tools-section">
          <button className="tools-button">
            <img src={settingsIcon} alt="Tools" />
          </button>
        </div>
      </div>

      <form onSubmit={handleSaveProfile} className="doctor-profile-edit-form">
        {/* Profile Photo Section with upload status */}
        <div className="doctor-profile-edit-section doctor-profile-edit-photo-section">
          <div className="doctor-profile-edit-photo-upload-area">
            <div className="doctor-profile-edit-photo-preview">
              {uploading ? (
                <div className="doctor-profile-edit-photo-uploading">
                  <div className="doctor-profile-edit-upload-spinner"></div>
                  <p className="doctor-profile-edit-upload-text">Uploading...</p>
                </div>
              ) : profileImagePreview ? (
                <img 
                  src={profileImagePreview} 
                  alt="Profile Preview" 
                  className="doctor-profile-edit-photo-image"
                />
              ) : (
                <div className="doctor-profile-edit-photo-placeholder">
                  {formData.firstName.charAt(0)}{formData.lastName.charAt(0)}
                </div>
              )}
            </div>
            <div className="doctor-profile-edit-photo-upload-controls">
              <label 
  htmlFor="photo-upload" 
  className={`doctor-profile-edit-upload-button ${uploading ? 'doctor-profile-edit-disabled' : ''}`}
>
  <img 
    src={uploadIcon} 
    alt="upload" 
    className="doctor-profile-edit-upload-icon"
  />
</label>
              <input
                id="photo-upload"
                type="file"
                accept="image/*"
                onChange={handleProfileImageChange}
                disabled={uploading}
                style={{ display: 'none' }}
              />
            </div>
          </div>
        </div>

        {/* Basic Information - Only Essential Fields */}
        <div className="doctor-profile-edit-section">
          <div className="doctor-profile-edit-form-row">
            <div className="doctor-profile-edit-form-group">
              <label htmlFor="firstName" className="doctor-profile-edit-form-label">
                First Name
              </label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                required
                className="doctor-profile-edit-form-input"
              />
            </div>
            <div className="doctor-profile-edit-form-group">
              <label htmlFor="lastName" className="doctor-profile-edit-form-label">
                Last Name *
              </label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                required
                className="doctor-profile-edit-form-input"
              />
            </div>
          </div>

          <div className="doctor-profile-edit-form-group">
            <label htmlFor="title" className="doctor-profile-edit-form-label">
              Professional Title
            </label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="e.g., Dr., LCSW, RPSY"
              className="doctor-profile-edit-form-input"
            />
          </div>
        </div>

        {/* Save Button */}
        <div className="doctor-profile-edit-form-actions">
          <button 
            type="submit" 
            className="doctor-profile-edit-save-button"
            disabled={saving || uploading}
          >
            {saving ? 'Saving...' : 'Save & Update'}
          </button>
        </div>
      </form>
    </div>
  );
};

const renderPublicProfile = () => {
  return (
    <div className="profile-content">
      <div className="content-header">
        <h2>Public Profile</h2>
        <div className="tools-section">
          <button className="tools-button">
            <img src={settingsIcon} alt="Tools" />
          </button>
        </div>
      </div>

      <div className="public-profile-overview">
        <div className="profile-preview-card">
          <div className="profile-actions">
            <button 
              className="action-button view-button"
              onClick={() => setShowViewModal(true)}
            >
              View Public Profile
            </button>
            <button 
              className="action-button edit-button"
              onClick={() => setShowEditModal(true)}
            >
              Edit Public Profile
            </button>
          </div>
        </div>
      </div>

      {/* Render the modals */}
        <ViewPublicProfileModal 
          showViewModal={showViewModal}
          setShowViewModal={setShowViewModal}
          setShowEditModal={setShowEditModal}
          doctorProfile={doctorProfile}
          safeRender={safeRender}
        />
        <EditPublicProfileModal 
          showEditModal={showEditModal}
          setShowEditModal={setShowEditModal}
          publicProfileData={publicProfileData}
          setPublicProfileData={setPublicProfileData}  // ← ADD THIS LINE
          handlePublicProfileChange={handlePublicProfileChange}
          handleSavePublicProfile={handleSavePublicProfile}
          saving={saving}
        />
    </div>
  );
};

  const renderPlaceholderSection = (title) => (
    <div className="profile-content">
      <div className="content-header">
        <h2>{title}</h2>
      </div>
      <div className="placeholder-content">
        <p>This section is coming soon.</p>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (activeSection) {
      case 'edit-profile':
        return renderEditProfile();
      case 'change-password':
        return renderChangeEmailPassword(); 
      case 'doctor-application':
          return renderDoctorApplication();
      case 'public-profile':
          return renderPublicProfile();
      case 'help-guide':
        return renderPlaceholderSection('Help & Guide (HIRS)');
      default:
        return renderEditProfile();
    }
  };

  if (loading) {
    return (
      <div className="neurolex-loading-container">
        <div className="neurolex-loading-insideContainer">
        <div className="neurolex-dashboard-spinner">
          <div className="spinner-circle outer"></div>
          <div className="spinner-circle middle"></div>
          <div className="spinner-circle inner"></div>
          <div className="spinner-center">
            <img 
              src={neurolexLogo} 
              alt="NeuroLex Logo" 
              className="loading-logo"
              onError={(e) => {
                console.warn('❌ Logo failed to load from:', neurolexLogo);
                // Fallback to patient emoji if logo doesn't load
                e.target.style.display = 'none';
                const fallback = e.target.nextElementSibling;
                if (fallback) {
                  fallback.style.display = 'flex';
                  fallback.style.alignItems = 'center';
                  fallback.style.justifyContent = 'center';
                }
              }}
              onLoad={() => {
                console.log('✅ NeuroLex logo loaded successfully:', neurolexLogo);
              }}
            />
            <div className="loading-logo-fallback" style={{ display: 'none' }}>
              👥
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }

  return (
    <div className="doctor-profile-container">
      <div className="profile-header">
        <div className="header-left">
          <div className="header-title">
            <h1>My Professional Profile</h1>
            <p>Keep your information and availability up to date.</p>
          </div>
        </div>
      </div>

      <div className="profile-layout">
        {renderSidebarMenu()}
        {renderContent()}
      </div>
    </div>
  );
};

export default DoctorProfile;